<form [formGroup]='currencyExchangeForm' id='{{formGroupName}}' (ngSubmit)='onSubmit()'>

	<div class='step-title service-title' i18n>Exchanging Currency</div>
	<div class='step-description' i18n>Exchange currencies at competitive rates before you move</div>

	<div class='currency-exchange-fields '>
		<div class="from-to-fields">
			<div class='form-control select-no-label'>
				<label i18n>Currency From</label>
				<mat-form-field appearance="outline" class=" full-width">
					<mat-select formControlName='fromCurrency'>
						<mat-option *ngFor="let currency of uniqueCurrencies" [value]="currency.currencyCode">
							{{ currency.currencyName }} ({{ currency.currencyCode }})
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
			<div class='exchange-arrow'>
				<span>&#8646;</span>
			</div>
			<div class='form-control select-no-label'>
				<label i18n>Currency To</label>
				<mat-form-field appearance="outline" class="full-width">
					<mat-select formControlName='toCurrency'>
						<mat-option *ngFor="let currency of uniqueCurrencies" [value]="currency.currencyCode">
							{{ currency.currencyName }} ({{ currency.currencyCode }})
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</div>	

		<div class="amount-fields">
			<div class='form-control select-no-label'>
				<label i18n>Select amount</label>
				<mat-form-field appearance="outline" class="full-width">
					<mat-select formControlName='fromAmount'>
						<mat-option value='0-5000'>0 - 5000</mat-option>
						<mat-option value='5000-10000'>5000 - 10000</mat-option>
						<mat-option value='10000-25000'>10000 - 25000</mat-option>
						<mat-option value='25000-100000'>25000 - 100000</mat-option>
						<mat-option value='100000-250000'>100000 - 250000</mat-option>
						<mat-option value='250000+'>250000+</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</div>
	</div>

	<!-- Mobile Navigation Buttons -->
	<div class='step-footer step-footer-center'>
		<div class='step-footer-buttons'>
			<button class='back' type='button' (click)='formService.backThirdParty()'>
				<mat-icon svgIcon='icons:chevron-left'></mat-icon>
				<ng-container i18n='@@buttonBack'>Back</ng-container>
			</button>
			<button class='submit' type='submit'>
				<ng-container *ngIf='formService.isLastThirdPartyStep()' i18n='buttonSaveSelection'>Save</ng-container>
				<ng-container *ngIf='!formService.isLastThirdPartyStep()' i18n='@@buttonContinue'>Continue</ng-container>
				<mat-icon svgIcon='icons:chevron-right'></mat-icon>
			</button>
		</div>
	</div>
</form>
